// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1vg8e","title":"Info_title__177Td","links":"Info_links__y0IBX","link":"Info_link__2jza2","logo":"Info_logo__1C2vJ"};